// removed by extract-text-webpack-plugin
module.exports = {"attendee-detail-float":"attendee-detail-float","attendee_name":"attendee_name","birthday-label":"birthday-label","email-label":"email-label","phone-label":"phone-label","birthday-input":"birthday-input","email-input":"email-input","phone-input":"phone-input"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Floats/RegistrationTableFloat/RegistrationTableFloat.scss
// module id = XsBs
// module chunks = 0